import { render, staticRenderFns } from "./EntranceDoor.vue?vue&type=template&id=0cb6f482&scoped=true&"
import script from "./EntranceDoor.vue?vue&type=script&lang=js&"
export * from "./EntranceDoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6f482",
  null
  
)

export default component.exports